import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material'
import type { Inquiry, InquiryBoolHeaderKey } from '../../../../models/Inquiry'
import { handleChangeBool } from '../../../../utils/inquiry/inquiryStateHandler'

interface BooleanRadioFormProps {
  label?: string
  keyName: InquiryBoolHeaderKey
  inquiry: Inquiry
  setInquiry: React.Dispatch<React.SetStateAction<Inquiry>>
  undefinedValue?: string
  trueValue?: string
  falseValue?: string
  disabled?: boolean
}

export const BooleanRadioForm: React.FC<BooleanRadioFormProps> = (
  props: BooleanRadioFormProps
) => {
  const {
    label,
    keyName,
    inquiry,
    setInquiry,
    undefinedValue,
    trueValue,
    falseValue,
    disabled,
  } = props
  return (
    <div className="pt-1">
      <FormControl disabled={disabled}>
        <FormLabel id={`bool-radio-${keyName}-id`}>{label}</FormLabel>
        <RadioGroup
          aria-labelledby={`bool-radio-${keyName}-id`}
          name={`bool-radio-${keyName}-group`}
          value={inquiry[keyName] != null ? inquiry[keyName] : ''}
          onChange={handleChangeBool({
            key: keyName,
            inquiry,
            setInquiry,
          })}
        >
          <div className="flex">
            <FormControlLabel
              value={''}
              control={<Radio />}
              label={undefinedValue ?? '未選択'}
            />
            <FormControlLabel
              value={true}
              control={<Radio />}
              label={trueValue ?? '有'}
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label={falseValue ?? '無'}
            />
          </div>
        </RadioGroup>
      </FormControl>
    </div>
  )
}
